import { useEffect, useState } from 'react';

import { Translate } from '@spazious/dollhouse-i18n';
import { useStore } from '@spazious/dollhouse-store';
import { Flex, Typography } from '@spazious/dollhouse-uikit';
import { traverseVisible } from '@spazious/dollhouse-utils';
import { VirtualFurnitureAttributesFurnitureTypeEnum } from '@spazious/react-backoffice';
import { useEventCallback } from '@spazious/react-hooks';

const tableTypes = [
  VirtualFurnitureAttributesFurnitureTypeEnum.RoundedTable,
  VirtualFurnitureAttributesFurnitureTypeEnum.SquareTable,
  VirtualFurnitureAttributesFurnitureTypeEnum.CocktailTable,
  VirtualFurnitureAttributesFurnitureTypeEnum.BoardroomTable,
];
const chairTypes = [VirtualFurnitureAttributesFurnitureTypeEnum.Chair];

export const FurnitureStats = () => {
  const graph = useStore(({ graph }) => graph);
  const [statsState, setStatsState] = useState({
    furnitures: 0,
    farrangements: 0,
    flayouts: 0,
    fshapes: 0,
    chairs: 0,
    tables: 0,
  });

  const updateStats = useEventCallback(() => {
    const stats = {
      furnitures: 0,
      farrangements: 0,
      flayouts: 0,
      fshapes: 0,
      chairs: 0,
      tables: 0,
    };

    traverseVisible(graph as any, (node) => {
      switch (node.type) {
        case 'furniture':
          stats.furnitures += 1;

          if (chairTypes.includes(node.furnitureType)) {
            stats.chairs += 1;
          } else if (tableTypes.includes(node.furnitureType)) {
            stats.tables += 1;
          }
          break;
        case 'farrangement':
          stats.farrangements += 1;
          break;
        case 'flayout':
          stats.flayouts += 1;
          break;
        case 'fshape':
          stats.fshapes += 1;
          break;
      }
    });

    if (
      statsState.furnitures !== stats.furnitures ||
      statsState.fshapes !== stats.fshapes ||
      statsState.flayouts !== stats.flayouts ||
      statsState.chairs !== stats.chairs ||
      statsState.tables !== stats.tables
    ) {
      setStatsState(stats);
    }
  });

  useEffect(
    () =>
      graph.subscribe(() => {
        updateStats();
      }),
    [graph, updateStats]
  );

  return (
    <Flex column gap="var(calc(--spacing-gap / 2))">
      <Typography size="large" variant="label">
        <Translate>Tables:</Translate> {statsState.tables}
      </Typography>
      <Typography size="large" variant="label">
        <Translate>Chairs:</Translate> {statsState.chairs}
      </Typography>
    </Flex>
  );
};
